/**
 * Created by mateimisarca on 27.03.2021
 */

import Series from './series';

export default Series;
